module.exports = __webpack_public_path__ + "img/90˚ TURNING CONVEYOR.2d7187b0.jpg";